import type { ViewProps } from "./types";
import { StatItem } from "../parts/StatItem";
import { radiusClass, shadowClass } from "../parts/themeTokens";

/**
 * Vertical list — fits sidebars or narrow embed columns.
 */
export function StackedView({ cfg, items, theme }: ViewProps) {
  const radius = radiusClass(cfg.radius);
  const shadow = shadowClass(cfg.shadow, theme === "transparent");
  const borderClass = cfg.border ? "border" : "";
  const gap = cfg.density === "compact" ? "space-y-1.5" : cfg.density === "comfortable" ? "space-y-3" : "space-y-2";
  return (
    <div className={"flex h-full flex-col " + gap + " p-3 sm:p-4"}>
      {items.map((it, i) => (
        <div
          key={it.k}
          className={"px-4 py-3 " + radius + " " + borderClass + " " + shadow}
          style={{ background: "var(--lm-card-bg)", borderColor: "var(--lm-card-border)" }}
        >
          <StatItem k={it.k} value={it.value} label={it.label} cfg={cfg} delayMs={i * 60} />
        </div>
      ))}
    </div>
  );
}
